import { Tooltip, TooltipContent, TooltipTrigger } from "@shared/ui/tooltip";
import React from "react";

interface TruncateProps {
  text: string;
  maxLength?: number;
}

export const HoverRevealText: React.FC<TruncateProps> = ({
  text,
  maxLength = 25,
}) => {
  if (!text) return <p className="text-xs">NA</p>;
  const isTruncated = text?.length > maxLength;
  const displayText = isTruncated ? text.slice(0, maxLength) + "..." : text;

  return (
    <Tooltip>
      <TooltipTrigger>
        <span className="cursor-pointer">{displayText}</span>
      </TooltipTrigger>
      <TooltipContent
        side="top"
        align="center"
        className="max-w-xs whitespace-pre-wrap break-words text-xs p-2"
      >
        {text}
      </TooltipContent>
    </Tooltip>
  );
};
